import { Component, OnInit } from '@angular/core';
import { ProductVersion, toEntityDict } from '@prism/prism-shared';
import { first, forkJoin, tap } from 'rxjs';
import { PlasticsApiService } from '../../../shared/services/plastics-api.service';
import { ScreenService } from '../../../shared/services/screen.service';

interface StationSchedule {
    stationName: string;
    products: {
        version: ProductVersion;
        completedQuantity: number;
        totalQuantity: number;
    }[];
}


@Component({
    selector: 'prism-client-print-finishing-schedule',
    templateUrl: './print-finishing-scehdule.component.html',
    styleUrls: ['./print-finishing-scehdule.component.scss']
})

export class PrintFinishingScehduleComponent implements OnInit {


    public schedule!: StationSchedule;

    constructor(
        private screen: ScreenService,
        private plasticsApiService: PlasticsApiService,
    ) { }

    ngOnInit() {
        this.screen.hideMainHeader$.next(true);
        this.printFinishingSchedule(0);
    }

    public printFinishingSchedule(
        stationIndex = 0,
    ) {
        forkJoin([
            this.plasticsApiService.loadPlasticsFinishingStations(),
            this.plasticsApiService.loadReleasedProductVersions()
        ]).pipe(
            first(),
            tap(([stations, versions]) => {
                interface StationSchedule {
                    stationName: string;
                    products: {
                        version: ProductVersion;
                        completedQuantity: number;
                        totalQuantity: number;
                    }[];
                }


                const taskIds = stations.map(list => list.taskIds).flat()

                this.plasticsApiService.loadFinishingTasksByIds(taskIds).pipe(
                    first(),
                    tap((tasks) => {
                        const productIdToVersionDict = toEntityDict(versions, 'productId');
                        const taskDict = toEntityDict(tasks);


                        const finishingSchedules: StationSchedule[] = stations.map((station) => {
                            const products = station.taskIds.map((taskId) => {
                                const task = taskDict[taskId];
                                const version = productIdToVersionDict[task?.productId]
                                return {
                                    version,
                                    completedQuantity: task.completedQuantity,
                                    totalQuantity: task.quantityToFinish
                                }

                            })
                            return {
                                stationName: station.name,
                                products,
                            }
                        })
                        this.schedule = finishingSchedules[stationIndex];


                    })
                ).subscribe()


            })
        ).subscribe()

    }
}
